/**
 * EmptyState — friendly "no data" placeholder.
 *
 * Props:
 *   title    — primary message
 *   subtitle — optional explanation
 *   action   — optional ReactNode (e.g. a "+ Add Task" button)
 *   icon     — optional ReactNode (e.g. an Icon)
 */

export default function EmptyState({ title, subtitle, action, icon }) {
  return (
    <div className="flex flex-col items-center text-center py-12 px-6">
      {icon && (
        <div className="w-12 h-12 rounded-full grid place-items-center bg-slate-100 text-muted mb-4">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-ink mb-1">{title}</h3>
      {subtitle && (
        <p className="text-sm text-muted max-w-sm mb-4">{subtitle}</p>
      )}
      {action}
    </div>
  );
}